import { useAppSelector } from '../app/hooks'
import { RootState } from '../app/store'
import { CaseDossier, DossierType, DossierTypeEnum } from '../shared/types'

export const getDossierType = (state: RootState): DossierType | null => {
  return state.zone?.data?.type ?? null
}

export const getDossierWithType = (state: RootState) => {
  return {
    ...state.dossier.data,
    type: state.zone?.data?.type ?? null,
  }
}

// TODO: delete this when removing type BRIEF
export const useCaseDossier = (): CaseDossier | null => {
  return useAppSelector((state) => {
    const zone = state.zone.data
    const dossier = state.dossier.data

    if (zone?.type === 'case') {
      return dossier as CaseDossier
    }

    return null
  })
}
